/// <amd-module name="typeahead/core/presentation/DropDownHideHandlersAssembly" />

import {DefaultPluginAssembly} from "typeahead/core/plugins/DefaultPluginAssembly";
import {IDropDownHideHandler} from "typeahead/core/presentation/IDropDownHideHandler";

export class DropDownHideHandlersAssembly {
    private handlers: IDropDownHideHandler[];

    public constructor(pluginAssembly: IPluginAssembly) {
        this.handlers = pluginAssembly.get(DefaultPluginAssembly.dropDownHideHandler);
    }

    public runHandlers($dropDownElement: JQuery, $inputElement: JQuery, context: IContext): void {
        this.handlers.map((plugin: IDropDownHideHandler): void => {
            return plugin.handleDropDownHide($dropDownElement, $inputElement, context);
        });
    }
}
